var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1884 0.999958C14.2628 0.999958 10.2656 4.97995 10.2656 9.90136C10.2656 14.8228 14.2552 18.8027 19.1884 18.8027L19.1884 1.00762L19.1884 0.999958Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1884 0.999958C5.26283 0.999958 1.26562 4.97995 1.26562 9.90136C1.26562 14.8228 5.25516 18.8027 10.1884 18.8027L10.1884 1.00762L10.1884 0.999958Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8985 9.90262C29.8985 7.1381 27.652 4.89699 24.8809 4.89699C22.1097 4.89699 19.8633 7.1381 19.8633 9.90262C19.8633 12.6671 22.1097 14.9082 24.8809 14.9082C27.652 14.9082 29.8985 12.6671 29.8985 9.90262Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white.9fce4c1edcc9bfb083a3de6890d8667b.svg";
export { ForwardRef as ReactComponent };